module.exports = __webpack_public_path__ + "static/media/logo-vwm.172fa39a.png";